import React, { useEffect } from 'react';

function CorpInfo({ corp, onChange }) {
  useEffect(() => {
    console.log("📋 Corp info received:", corp);
  }, [corp]);

  return (
    <div className="tab-content">
      <label>Name:
        <input
          type="text"
          name="name"
          value={corp.name || ''}
          onChange={onChange}
        />
      </label>
      <label>Address:
        <input
          type="text"
          name="address"
          value={corp.address || ''}
          onChange={onChange}
        />
      </label>
      <label>City:
        <input
          type="text"
          name="city"
          value={corp.city || ''}
          onChange={onChange}
        />
      </label>
      <label>State:
        <input
          type="text"
          name="state"
          value={corp.state || ''}
          onChange={onChange}
        />
      </label>
      <label>Zip:
        <input
          type="text"
          name="zip"
          value={corp.zip || ''}
          onChange={onChange}
        />
      </label>
      <label>Country:
        <input
          type="text"
          name="country"
          value={corp.country || ''}
          onChange={onChange}
          placeholder="Enter country"
        />
      </label>
      <label>Status:
        <select name="status" value={corp.status || ''} onChange={onChange}>
          <option value="">Select status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
          <option value="Onboarding">Onboarding</option>
        </select>
      </label>
      <label>Start Date:
        <input
          type="date"
          name="startDate"
          value={corp.startDate || ''}
          onChange={onChange}
        />
      </label>
      <label>Website:
        <input
          type="url"
          name="website"
          value={corp.website || ''}
          onChange={onChange}
          placeholder="https://example.com"
        />
      </label>
    </div>
  );
}

export default CorpInfo;
